module.exports = __webpack_public_path__ + "img/img19.76c0e21.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/02/img19.png
// module id = 195
// module chunks = 0